import { render } from "./GlobalEmailTemplates.vue?vue&type=template&id=7951a65a&scoped=true"
import script from "./GlobalEmailTemplates.vue?vue&type=script&lang=js"
export * from "./GlobalEmailTemplates.vue?vue&type=script&lang=js"

import "./GlobalEmailTemplates.vue?vue&type=style&index=0&id=7951a65a&lang=css"
import "./GlobalEmailTemplates.vue?vue&type=style&index=1&id=7951a65a&scoped=true&lang=scss"

import exportComponent from "/Users/kovacsistvan/develop/segito-kezek/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7951a65a"]])

export default __exports__